// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__rkUJj","loader_text":"Loader_loader_text__fdiCk","pulsing":"Loader_pulsing__aaekU","more_dots":"Loader_more_dots__+EO8-"};